export default __webpack_public_path__ + "img/publication/publication5_480.webp";